export default __webpack_public_path__ + "static/img7h-3ae509345308c8b111044457eced2bfe.jpg";